import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import {AppConfig} from '../../app.config';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject }    from 'rxjs/Subject';
@Injectable()
export class AdminReportService {
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) { }
    executeReport(query:any) {
        return this.http.post(this.config.apiUrl +'reports/execute',{query:query}, this.setHeaders()).map((response: Response) => response.json());
    }
    saveReport(request:any) {
        return this.http.post(this.config.apiUrl+'reports/create',request,this.setHeaders()).map((response:Response) => response.json());
    }
    getAllReports(){
        return this.http.get(this.config.apiUrl + 'reports/findAll',this.setHeaders()).map((response:Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if(params)
                return new RequestOptions({ headers: headers , search : params });
            else
                return new RequestOptions({ headers: headers });
        }else{
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/admin.report.service.ts